import React from 'react';
import { Link } from 'react-router-dom';
import type { CatalogEmptyStateProps } from '../interfaces';
import './CatalogEmptyState.scss';

const CatalogEmptyState = ({
  eyebrow = 'Nothing to show',
  title,
  message,
  role = 'status',
  mark = 'TK',
  primaryAction = { label: 'View all jewelry', to: '/products' },
  secondaryAction = { label: 'Shop rings', to: '/products/types/Rings' },
}: CatalogEmptyStateProps) => (
  <section
    className="catalog-empty-state"
    role={role}
    aria-live={role === 'alert' ? 'assertive' : 'polite'}
  >
    <div className="catalog-empty-state__mark" aria-hidden="true">
      {mark}
    </div>
    <div className="catalog-empty-state__copy">
      <p className="catalog-empty-state__eyebrow">{eyebrow}</p>
      <h2>{title}</h2>
      <p className="catalog-empty-state__message">{message}</p>
      <div className="catalog-empty-state__actions">
        <Link
          className="catalog-empty-state__primary"
          to={primaryAction.to}
          reloadDocument={primaryAction.reloadDocument}
        >
          {primaryAction.label}
        </Link>
        <Link className="catalog-empty-state__secondary" to={secondaryAction.to}>
          {secondaryAction.label}
        </Link>
      </div>
    </div>
  </section>
);

export default CatalogEmptyState;
